import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const initialState = {
    nodes: [
        {
            id: uuidv4(),
            type: "defaultNode",
            data: { label: "System Title", content: "Describe your system here" },
            position: { x: 300, y: 100 },
            style: { background: "#1b5e20", color: "#fff", border: "1px solid #36bf51" },
        },
    ],
    edges: [],
    mapTitle: "Untitled Map",
    mapDescription: "",
};

const graphSlice = createSlice({
    name: "graph",
    initialState,
    reducers: {
        setNodes(state, action) {
            state.nodes = action.payload;
        },
        setEdges(state, action) {
            state.edges = action.payload;
        },
        addNode(state, action) {
            state.nodes.push(action.payload);
        },
        updateNode(state, action) {
            const index = state.nodes.findIndex((node) => node.id === action.payload.id);
            if (index !== -1) {
                state.nodes[index] = action.payload;
            }
        },
        saveMap(state, action) {
            const { title, description } = action.payload;
            state.mapTitle = title;
            state.mapDescription = description;
        },
    },
});

export const { setNodes, setEdges, addNode, updateNode, saveMap } = graphSlice.actions;

export default graphSlice.reducer;
